export function generic() {
	var body = document.querySelector('body')
	if (body.classList.contains('preload')) {
		body.classList.remove('preload')
	} else {
		setTimeout(preload, 500)
	}

	if (window.getComputedStyle(document.body).getPropertyValue('--accent-pri') && window.getComputedStyle(document.body).getPropertyValue('--accent-pri') != '#fff') {
		document.querySelector('meta[name="theme-color"]').setAttribute('content', window.getComputedStyle(document.body).getPropertyValue('--accent-pri'))
	}
}
